import { JoonUIColor, Typography } from "@joonapp/web-shared"

import useMobile from "../../hooks/useMobile"

export interface ImageCheckboxProps {
  name: string
  selected: boolean
  onChange: (event: any) => void
  imageURL: string
  imageAlt?: string
  label?: string | React.ReactNode
  subLabel?: string | React.ReactNode
  disabled?: boolean
  style?: React.CSSProperties
}

const ImageCheckbox: React.FC<ImageCheckboxProps> = ({
  name,
  selected,
  onChange,
  imageURL,
  imageAlt,
  label,
  subLabel,
  disabled = false,
}) => {
  const isMobile = useMobile()

  return (
    <button
      onClick={onChange}
      aria-checked={selected}
      role="checkbox"
      name={name}
      className="flex flex-1"
    >
      <div
        className={`flex flex-col py-3 px-2 rounded-md items-center user-select-none flex-1 border bg-white 
        ${selected ? "border-primary shadow-md" : "border-borderPrimary"}`}
      >
        <img
          src={imageURL}
          alt={imageAlt || name}
          style={{ minHeight: "90px", maxHeight: "90px" }}
        />
        <label htmlFor={name}>
          <div className="flex flex-col items-center">
            <Typography
              variant={isMobile ? "bodySmallBold" : "bodyBold"}
              style={{ whiteSpace: "wrap" }}
              color={
                disabled ? JoonUIColor.text.disabled : JoonUIColor.text.primary
              }
            >
              {label}
            </Typography>
            {subLabel && (
              <Typography
                variant={isMobile ? "bodyXSmall" : "bodySmall"}
                color={
                  disabled
                    ? JoonUIColor.text.disabled
                    : JoonUIColor.text.primary
                }
                style={{ whiteSpace: "wrap" }}
              >
                {subLabel}
              </Typography>
            )}
          </div>
        </label>
      </div>
    </button>
  )
}

export default ImageCheckbox
